import { useBoolean } from "react-use";
import { useAddSpaceGroupMemberModal } from "@circle-react/components/Modals/AddSpaceGroupMember";
import { useAddSpaceModal } from "@circle-react/components/Modals/AddSpaceModal";
import { useEditSpaceGroupModal } from "@circle-react/components/Modals/EditSpaceGroupModal";
import { canManageSpaceGroups } from "@circle-react/helpers/spaceGroupHelpers";
import type { SpaceGroup } from "@circle-react/types";

export interface UseManageSpaceGroupActionsProps {
  spaceGroup: SpaceGroup;
}

export const useManageSpaceGroupActions = ({
  spaceGroup,
}: UseManageSpaceGroupActionsProps) => {
  const canManage = canManageSpaceGroups({ spaceGroup });
  const [shouldShowDeleteModal, toggleDeleteModal] = useBoolean(false);
  const spaceModal = useAddSpaceModal();
  const editSpaceGroupModal = useEditSpaceGroupModal();
  const addSpaceGroupMemberModal = useAddSpaceGroupMemberModal();

  return {
    canManage,
    shouldShowDeleteModal,
    spaceModal,
    editSpaceGroupModal,
    addSpaceGroupMemberModal,
    toggleDeleteModal,
  };
};
